module.exports = __webpack_public_path__ + "static/media/Varmber_logga_ny.ee018773.png";